import React, { useEffect, useState } from 'react';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { maxBounds, minBounds, Patterns, VALIDATIONS_TEXT } from "../../../constants/Constants";
import Select, {
    components,
} from 'react-select';
import parse from 'html-react-parser';
import { ToastContainer, toast } from "react-toastify";
import { DatePicker } from 'rsuite';

const allStores = [
    { value: 'wallys', label: 'Wallys' },
    { value: 'burnetrd', label: 'Burnet Rd' },
    { value: 'manorrd', label: 'Manor Rd' }
]

const colourStyles = {
    control: styles => ({ ...styles, backgroundColor: 'white' }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            cursor: "pointer",
            backgroundColor: isDisabled ? 'red' : 'white',
            color: '#989898',
            textAlign: "left",
            ":hover": {
                backgroundColor: "#f4f4f4",
                color: "#126ADF"
            },
        }
    },
};


const EditTrainingPopup = (props) => {
    const [disable, setDisable] = useState(false);
    const { register, handleSubmit, setValue, reset, formState: { errors } } = useForm({
        mode: "onChange"
    });

    //On Close Button function
    const handleClose = () => props?.setEditPopup(false);

    //On Save Btn function

    //On Submit function
    const onSubmit = (data) => {

        setDisable(true);

        console.log("Edit Store Link", data);


        setTimeout(function () {
            setDisable(false);
            props?.setEditPopup(false)
            toast.success('Training Has Been Updated', {
                position: "bottom-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }, 4000);
    }


    useEffect(() => {
        reset({
            employename: 'Adamson Byron',
            store: 'Wallys',
            programname: "Management",
            date: "26/05/2022",
            completion: "23.54%"
        })
    }, [])
    return (
        <>

            <Modal
                className='editModal'
                show={true}
                size="md"
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton className='border-0 p-0 mb-4'>
                    <Modal.Title className='heading-small '>Edit Training</Modal.Title>
                </Modal.Header>
                <Modal.Body className='border-0 p-0'>
                    <Form onSubmit={handleSubmit(onSubmit)} className="roundedForm">
                        <div className="innerFormScroll">
                            <Row>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>Employee Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Link URL"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}
                                            maxLength={maxBounds.NAME}
                                            {...register("employename")}
                                        />
                                        {errors.name && <Form.Text>{errors.name.message}</Form.Text>}
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>Program Name</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Link URL"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}
                                            maxLength={maxBounds.NAME}
                                            {...register("programname")}
                                        />
                                        {errors.name && <Form.Text>{errors.name.message}</Form.Text>}
                                    </Form.Group>
                                </Col>

                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="signUpName">
                                        <Form.Label>Start Date</Form.Label>
                                        <DatePicker defaultValue={new Date('2022-05-26')} className='form-control' format="dd/MM/yyyy" block oneTap placement="bottomStart" />
                                    </Form.Group>
                                </Col>
                                <Col xs={12}>
                                    <Form.Group className="themeInputGroup mb-4" controlId="linkUrl">
                                        <Form.Label>Completion %</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder="Add Completion %"
                                            autoComplete="off"
                                            role={"presentation"}
                                            className={errors.linkUrl ? "hasError" : ""}
                                            {...register("completion", {
                                                required: {
                                                    value: true,
                                                    message: VALIDATIONS_TEXT.FIELD_REQUIRE
                                                },
                                                pattern: {
                                                    value: Patterns.Percentage,
                                                    message: "Must contain % sign and should be less than 100"
                                                },
                                                maxLength: {
                                                    value: '6',
                                                    message: 'Max Length is of 3 digits'
                                                }
                                            })}
                                        />
                                        {errors.completion && <Form.Text>{errors.completion.message}</Form.Text>}
                                    </Form.Group>
                                </Col>


                            </Row>
                        </div>
                        <div className="d-flex justify-content-end pt-3">
                            <Button type='submit' className="glowBtn"> {
                                !disable ? <>Save</> : <div className="load black"></div>
                            }</Button>
                        </div>
                        <ToastContainer />
                    </Form>


                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditTrainingPopup